module.exports = __webpack_public_path__ + "static/media/gallery.5ace9690.jpg";